$(document).ready(function(){
    
      
    $('.item_column').click(function(){
        var href = $(this).find('.item_url').attr('href');
        $(this).parents('.personalized-plan').find('.btn_url').attr('href', href);
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    });
    $('.personalized-plan-section').find('.item_column.active').trigger( "click" );
});